import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, Alert, Button, CircularProgress } from '@mui/material';
import apiService from '../../services/apiService';
import { API_ENDPOINTS } from '../../config/api';

// Email-cím csere megerősítése (pl. szolgáltatói meghívó beváltásakor megadott új belépési cím)
const ConfirmEmailChange = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState(token ? 'loading' : 'error'); // loading | success | error
  const [message, setMessage] = useState(token ? '' : 'Hiányzó megerősítő token.');
  const [newEmail, setNewEmail] = useState('');
  // A token egyszer használható — StrictMode dupla effektfuttatásánál se küldjük el kétszer
  const sentRef = useRef(false);

  useEffect(() => {
    if (!token || sentRef.current) return;
    sentRef.current = true;
    apiService.post(API_ENDPOINTS.AUTH.EMAIL_CHANGE_CONFIRM, { token })
      .then((response) => {
        setNewEmail(response?.data?.email || '');
        setStatus('success');
      })
      .catch((err) => {
        setMessage(err?.message || 'Hiba történt a megerősítés során.');
        setStatus('error');
      });
  }, [token]);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Email cím megerősítése</Typography>

        {status === 'loading' && <CircularProgress sx={{ my: 3 }} />}

        {status === 'success' && (
          <>
            <Alert severity="success" sx={{ my: 3, textAlign: 'left' }}>
              Az email címét megerősítettük. Mostantól a(z) <strong>{newEmail}</strong> címmel tud bejelentkezni.
            </Alert>
            <Button component={Link} to="/login" variant="contained">Bejelentkezés</Button>
          </>
        )}

        {status === 'error' && (
          <>
            <Alert severity="error" sx={{ my: 3, textAlign: 'left' }}>
              {message} Ha a link lejárt, a korábbi email címével továbbra is be tud lépni; segítségért írjon a hello@wedigo.hu címre.
            </Alert>
            <Button component={Link} to="/" variant="contained">Vissza a főoldalra</Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default ConfirmEmailChange;
